// @ai-generated 2026-08-06T09:13:59+00:00 by kai.cissarek@synqony.com using Claude Opus 5
import type { SelectOption } from '@synqo/frontend-component-library';
import { EnumContainerOrderAction } from './Generated';

export const getEnumContainerOrderActionLabel = (value: EnumContainerOrderAction) => {
    switch (value) {
        case EnumContainerOrderAction.Place:
            return 'Stellen';
        case EnumContainerOrderAction.Collect:
            return 'Abholen';
        case EnumContainerOrderAction.Empty:
            return 'Leeren';
        default:
            return 'Nicht definiert';
    }
};

// @ai-generated 2026-09-25T10:46:31+00:00 by matthias.gessinger@synqony.com using Claude Opus 5.5 (1M context)
/** The actions an order can plan, without `NotDefined`. */
export const containerOrderActionOptions: SelectOption<EnumContainerOrderAction>[] = [
    EnumContainerOrderAction.Place,
    EnumContainerOrderAction.Collect,
    EnumContainerOrderAction.Empty,
].map((action) => ({
    name: EnumContainerOrderAction[action].toLowerCase(),
    label: getEnumContainerOrderActionLabel(action),
    value: action,
}));
